<nav class="navbar-default navbar-static-side" role="navigation" [hidden]="!auth.currentUser">
    <div>
        <ul class="nav metismenu" id="side-menu">
            <li routerLinkActive="active">
                <a [routerLink]="['/home']">Home</a>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('customers') }" [hidden]="!showCustomer()">
                <a href="#"><span class="nav-label">Customers</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active" [hidden]="!showCustomer()"><a [routerLink]="['/customers/overview']">Customers</a></li>
                    <li routerLinkActive="active" [hidden]="!showQuote()"><a [routerLink]="['/customers/quotes/overview']">Quotes</a></li>
                    <!-- <li routerLinkActive="active" [hidden]="!showCustomer()"><a [routerLink]="['/customers/loads']">Load Overview</a></li> -->
                    <!-- <li routerLinkActive="active" [hidden]="!showCustomer()"><a [routerLink]="['/customers/projects']">Projects</a></li> -->
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('products') }" [hidden]="!showProducts()">
                <a href="#"><span class="nav-label">Products</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/products/overview']">Overview</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/products/inventory']">Inventory</a></li>
                    <!-- <li routerLinkActive="active"><a [routerLink]="['/products/inventory']">Purchases</a></li> -->
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('invoices') || activeRoute('payments') }" [hidden]="!showInvoices()">
                <a href="#"><span class="nav-label">Invoices</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active" [hidden]="!showInvoices()"><a [routerLink]="['/invoices/loads']">Loads</a></li>
                    <li routerLinkActive="active" [hidden]="!showInvoices()"><a [routerLink]="['/invoices/overview']">Invoices</a></li>
                    <li routerLinkActive="active" [hidden]="!showInvoices()"><a [routerLink]="['/payments/overview']">Payments</a></li>
                    <li routerLinkActive="active" [hidden]="!showInvoices()"><a [routerLink]="['/invoices/load-history']">Load History</a></li>
                    <li routerLinkActive="active" [hidden]="!showInvoices()"><a [routerLink]="['/invoices/history']">Invoice History</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('vendors') }"  [hidden]="!showVendors()">
                <a href="#"><span class="nav-label">Vendors</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/vendors/overview']">Overview</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('reports') }" [hidden]="!showReports()">
                <a href="#"><span class="nav-label">Reports</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/reports/tax-code-summary']">Tax Code</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/reports/sales-summary']">Sales</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('quickbooks') }" [hidden]="!showQuickBooks()">
                <a href="#"><span class="nav-label">QuickBooks</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/quickbooks/overview']">Overview</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/quickbooks/journal-entry-overview']">Journal Entries</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('admin') }" [hidden]="!showAdmin()">
                <a href="#"><span class="nav-label" style="font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">Admin</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/admin/lookup-tables']">Lookup Tables</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/users']">Users</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/statements']">Statements</a></li>
                </ul>
            </li>
        </ul>
        <div style="padding: 30px 25px 0px; font-size: 8pt; color: aliceblue" title="{{ appInfo.clientVersion }}">version: <strong>{{ appInfo.clientVersion }}</strong></div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">user: {{ auth.currentUser?.userName }}</div>
    </div>
</nav>
